import { render, staticRenderFns } from "./LayoutBlocks.vue?vue&type=template&id=59018974&scoped=true&"
import script from "./LayoutBlocks.vue?vue&type=script&lang=ts&"
export * from "./LayoutBlocks.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutBlocks.vue?vue&type=style&index=0&id=59018974&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59018974",
  null
  
)

export default component.exports